import { FooterNavigator } from '../Footer/FooterNavigator';
import { FooterNavigatorProps } from '../Footer/types';
import { useStrategiesContext } from './StrategiesContext';
import { ConfirmAction } from './Modals/ConfirmAction';
import { useTranslation } from 'react-i18next';

const OPTIONS = ['Archive', 'Delete', 'Resume'];

export const ArchiveResumeDelete = () => {
  const {
    option,
    loadingArchivation,
    loadingResumeStrategy,
    loadingStrategies,
    strategy,
    archiveStrategy,
    resumeStrategy,
    closeModal,
    dispatch,
    deleteStrategy,
    loadingDeletion,
  } = useStrategiesContext();

  const loading =
    loadingResumeStrategy ||
    loadingArchivation ||
    loadingStrategies ||
    loadingDeletion;

  const { t } = useTranslation();

  const [isArchive, isDelete, isResume] = OPTIONS.map((opt) => opt === option);

  const saveChanges = () => {
    const variables = { strategyId: strategy?.id };

    isArchive && archiveStrategy!({ variables });
    isDelete &&
      deleteStrategy &&
      deleteStrategy({ variables }).then((ret) => {
        if (ret?.data?.deleteStrategy?.id)
          dispatch({
            element: (
              <ConfirmAction action="deleted" strategyName={strategy!.name} />
            ),
          });
      });
    isResume && resumeStrategy!({ variables });
  };

  return (
    <div className="flex flex-col px-10 gap-3 py-10 my-10">
      <div className="text-center font-medium text-xl ">
        {isDelete
          ? t('strategies.actions.delete.title')
          : isArchive
          ? t('strategies.actions.archive.title')
          : t('strategies.actions.unarchive.title')}
      </div>

      <div className="text-grey-50 text-center">
        {isDelete
          ? t('strategies.actions.delete.description')
          : isArchive
          ? t('strategies.actions.archive.description')
          : t('strategies.actions.unarchive.description')}
      </div>

      {/* footer */}
      <FooterNavigator
        loading={loading}
        saveButtonName={option as FooterNavigatorProps['saveButtonName']}
        saveButtonVariant={isDelete ? 'negative' : 'primary'}
        onCancel={closeModal}
        onSave={saveChanges}
      />
    </div>
  );
};
